import CrossSVG from "@/Images/svg/remove-cross.svg";
import { IconButton } from "@mui/material";
import { format, subDays } from "date-fns";
import React, { ForwardedRef, forwardRef, useEffect } from "react";
import { useActions } from "../../../../Hooks/redux/useActions";
import { useAppSelector } from "../../../../Hooks/redux/useAppSelector";
import basicStyles from "../../../../Theme/modalsElements.module.scss";
import DetailAppStatistic from "./components/lists/DetailAppStatistic/DetailAppStatistic";
import StatisticAppsList from "./components/lists/StatisticAppsList/StatisticAppsList";
import styles from "./Statistic.module.scss";

interface OrdersStatisticModuleProps {
  initDateStart: string;
  initDateStop: string;
  onClose: () => void;
}

const OrdersStatisticModule: React.ForwardRefExoticComponent<OrdersStatisticModuleProps> =
  forwardRef(
    (
      { initDateStart, initDateStop, onClose },
      ref: ForwardedRef<HTMLDivElement>
    ) => {
      const {
        setStatisticDateStart,
        setStatisticDateStop,
        clearStatisticState,
      } = useActions();
      const { appInfo } = useAppSelector(
        (state) => state.myOrdersStatisticSlice
      );
      const dateStart = format(subDays(new Date(), 6), "yyyy-MM-dd");
      const dateEnd = format(new Date(), "yyyy-MM-dd");

      useEffect(() => {
        setStatisticDateStart(initDateStart || dateStart);
        setStatisticDateStop(initDateStop || dateEnd);

        return () => {
          clearStatisticState();
        };
      }, []);

      return (
        <div
          className={basicStyles.modal_wrapper + " " + styles.modal}
          ref={ref}
          tabIndex={-1}
        >
          <IconButton onClick={onClose} className={styles.close_button}>
            <img src={CrossSVG} alt="Cross" />
          </IconButton>
          {!appInfo ? (
            <StatisticAppsList />
          ) : (
            <DetailAppStatistic detailId={appInfo.application} />
          )}
        </div>
      );
    }
  );

export default OrdersStatisticModule;
